export default __webpack_public_path__ + "img/eOKkXWgq.d368f462.svg";